import { Flex, Image, Text, useColorModeValue } from '@chakra-ui/react';
import React from 'react';
import Marquee from 'react-fast-marquee';

import { COMMON_WEB_PATH } from '../../constant';
import useCheckLogin from '../../hook/useCheckLogin';
import useMarqueeList from '../../hook/useMarqueeList';

const MarqueeList = () => {
  const marqueeList = useMarqueeList();

  const { isLogin, isMachineUser, isMachineDomain } = useCheckLogin();

  const bg = useColorModeValue('light.200', '#262D47');
  const color = useColorModeValue('dark.100', 'text.100');

  return (
    <Flex
      //bg={bg}
      bgSize="100% 100%"
      bgPosition="center"
      bgRepeat="no-repeat"
      color="#fff"
      alignItems={`center`}
      gap={`10px`}
      px="5px"
      pl="25px"
      py="5px"
      // w="100%"
      w={{ base: '100%', md: '100%' }}
      overflow="hidden"
      minH="39px"
      maxH="50px"
    >
      {/* <Icon as={AiFillSound} color="#fff" /> */}
      <Image
        src={`${COMMON_WEB_PATH}/blue-layout/header/marquee_icon.png`}
        w={{
          base: '20px',
          md: '25px'
        }}
        display={{ base: 'block', md: 'block' }}
      />
      <Marquee className="">
        {marqueeList?.map((item, index) => {
          const { subject, content } = item;
          return (
            <Flex mr="40px" key={`marquee-${index}`}>
              <Text
                color="white"
                textShadow={'0px 0px 3px rgba(0,0,0,0.3)'}
                fontWeight={'medium'}
                fontSize={{
                  base: 'md',
                  md: 'lg'
                }}
              >
                {content}
              </Text>
            </Flex>
          );
        })}
      </Marquee>
    </Flex>
  );
};

export default MarqueeList;
